<div class="field"
  [class.field_error]="hasError() && errorKey && hasDisplayErrorText"
  [class.field_compact]="!isInline || deviceService.isMobile()"
  [class.field_no-label]="!label">
  <div class="field__label"> {{ label }} </div>
  <div class="field__content">

    <ng-content></ng-content>

    <div class="field__text" [@error] *ngIf="hasError() && errorKey && hasDisplayErrorText">

      <ng-container [ngSwitch]="errorKey">
        <span *ngSwitchCase="'min'">{{ 'error.min' | customLocale: {'n': control.errors.min.min} }}</span>
        <span *ngSwitchCase="'max'">{{ 'error.max' | customLocale: {'n': control.errors.max.max} }}</span>
        <span *ngSwitchCase="'required'">{{ 'error.required' | customLocale }}</span>
        <span *ngSwitchCase="'requiredTrue'">{{ 'error.required' | customLocale }}</span>
        <span *ngSwitchCase="'minlength'">{{ 'error.min-length' | customLocale: {'n': control.errors.minlength.requiredLength} }}</span>
        <span *ngSwitchCase="'maxlength'">{{ 'error.max-length' | customLocale: {'n': control.errors.maxlength.requiredLength} }}</span>
        <span *ngSwitchCase="'whitespace'">{{ 'error.whitespace' | customLocale }}</span>
        <span *ngSwitchCase="'confirm'">{{ 'error.confirm' | customLocale }}</span>
        <span *ngSwitchCase="'pattern'">
          <span *ngIf="patternError">{{patternError}}</span>
          <span *ngIf="!patternError">{{ 'error.pattern' | customLocale }}</span>
        </span>

        <!-- For custom validators -->
        <span *ngSwitchDefault>
          {{ control.errors[errorKey].text | customLocale }}
        </span>
      </ng-container>
    </div>
  </div>
</div>
